module.exports = __webpack_public_path__ + "d74fb014d75539b19b3b05f99ec1292c.svg";